import React, { Component } from 'react'
import { Collapse, CardBody, Card } from 'reactstrap';
import { Link } from 'react-router-dom'
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home2',
    //     submenu: [
    //         {
    //             id: 11,
    //             title: 'Home style 1',
    //             link: '/home'
    //         },
    //         {
    //             id: 12,
    //             title: 'Home style 2',
    //             link: '/home2'
    //         },
    //         {
    //             id: 13,
    //             title: 'Home style 3',
    //             link: '/home3'
    //         },
    //         {
    //             id: 13,
    //             title: 'Home style 4',
    //             link: '/home4'
    //         },
    //     ]
    },

    {
        id: 2,
        title: 'About',
        link: '/about',
        submenu: [
            {
                id: 21,
                title: 'Hazrat Pir Qasim Sadiq',
                link: '/about-1'
            },
            {
                id: 22,
                title: 'Hazrat Pir Nazeer Ahmad',
                link: '/about-2'
            },
            {
                id: 23,
                title: 'Hazrat Pir Gul Badshah',
                link: '/about-3'
            },
            {
                id: 24,
                title: 'Hazrat Pir Farooq Gul Badshah',
                link: '/about-4'
            },
            {
                id: 25,
                title: 'Hazrat Pir Mujtaba Farooq Gul',
                link: '/about-5'
            },
            {
                id: 26,
                title: 'Sahibzada Omer Farooq Gul',
                link: '/about-6'
            }
        ]
    },
    

{
    id: 3,
        title: 'Service',
        link: '/service',
        submenu: [
            {
                id: 31,
                title: 'Quran Memorization',
                link: '/service-quran-memorization'
            },
            {
                id: 32,
                title: 'Clean Water Bores',
                link: '/service-clean-water-bores'
            },
            {
                id: 33,
                title: 'Masjid Development',
                link: '/service-masjid-development'
            },
            {
                id: 34,
                title: 'Feeding The Needy',
                link: '/service-feeding-the-needy'
            },
            {
                id: 35,
                title: 'Child Sponsors',
                link: '/service-child-sponsors'
            },
            {
                id: 36,
                title: 'Animal Sacrifice',
                link: '/service-animal-sacrifice'
            },
        ]
    },
{
    id: 4,
        title: 'Event',
        link: '/event',
        // submenu: [
        //     {
        //         id: 41,
        //         title: 'Event',
        //         link: '/event'
        //     },
        //     {
        //         id: 42,
        //         title: 'Event Single',
        //         link: '/event-single'
        //     }
        // ]
    },
{
    id: 5,
        title: 'Donate',
        link: '/donate'
    },
{
    id: 88,
        title: 'Contact',
        link: '/contact',
}
    // {
    //     id: 7,
    //     title: 'Pages',
    //     link: '/',
    //     submenu: [
    //         {
    //             id: 71,
    //             title: 'About',
    //             link: '/about'
    //         },
    //         {
    //             id: 71,
    //             title: 'Shop',
    //             link: '/shop'
    //         },
    //         {
    //             id: 71,
    //             title: 'Shop Single',
    //             link: '/shop-single'
    //         },
    //         {
    //             id: 75,
    //             title: 'Donate',
    //             link: '/donate'
    //         },
    //         {
    //             id: 79,
    //             title: 'Error 404',
    //             link: '/404'
    //         },
            
    //     ]
    // },

    // {
    //     id: 5,
    //     title: 'Blog',
    //     link: '/blog',
    //     submenu: [
    //         {
    //             id: 51,
    //             title: 'Blog',
    //             link: '/blog'
    //         },
    //         {
    //             id: 52,
    //             title: 'Blog Left sidebar',
    //             link: '/blog-left'
    //         },
    //         {
    //             id: 53,
    //             title: 'Blog full width',
    //             link: '/blog-fullwidth'
    //         },
    //         {
    //             id: 54,
    //             title: 'Blog single',
    //             link: '/blog-details'
    //         },
    //         {
    //             id: 55,
    //             title: 'Blog single Left sidebar',
    //             link: '/blog-details-left'
    //         },
    //         {
    //             id: 56,
    //             title: 'Blog single Left sidebar',
    //             link: '/blog-details-fullwidth'
    //         },
    //     ]
    // },
    
]


export default class MobileMenu extends Component {

    state = {
        isMenuShow: false,
        isOpen: 0,
    }

    menuHandler = () => {
        this.setState({
            isMenuShow: !this.state.isMenuShow
        })
    }

    setIsOpen = id => () => {
        this.setState({
            isOpen: id === this.state.isOpen ? 0 : id
        })
    }

    render() {

        const { isMenuShow, isOpen } = this.state;

        const ClickHandler = () =>{
            window.scrollTo(10, 0);
         }

        return (
            <div>
                <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                    {/* <div className="clox" onClick={this.menuHandler}>Close Me</div> */}

                    <ul className="responsivemenu">
                        {menus.map(item => {
                            return (
                                <li key={item.id}>
                                    {item.submenu ? <p onClick={this.setIsOpen(item.id)}>
                                        {item.title}
                                        {item.submenu ? <i className="fa fa-angle-right" aria-hidden="true"></i> : ''}
                                    </p> : <Link to={item.link}>{item.title}</Link>}
                                    {item.submenu ?
                                    <Collapse isOpen={item.id === isOpen}>
                                        <Card>
                                            <CardBody>
                                                <ul>
                                                    {item.submenu.map(submenu => (
                                                        <li key={submenu.id}><Link onClick={ClickHandler} className="active" to={submenu.link}>{submenu.title}</Link></li>
                                                    ))}
                                                </ul>
                                            </CardBody>
                                        </Card>
                                    </Collapse>
                                    : ''}
                                </li>
                            )
                        })}
                    </ul>

                </div>

                <div className="showmenu" onClick={this.menuHandler}><i className="fa fa-bars" aria-hidden="true"></i></div>
            </div>
        )
    }
}
